import type { ApiResponse } from '@/shared/types';
import api from '@/shared/api/client';

export type NotificationAudience = 'all' | 'tenant' | 'user';

export type OperatorNotificationBroadcastInput = {
  audience: NotificationAudience;
  tenantId?: string;
  userId?: string;
  severity?: 'INFO' | 'SUCCESS' | 'WARNING' | 'ERROR';
  title: string;
  body?: string | null;
  actionUrl?: string | null;
};

export type OperatorNotificationBroadcastRecord = {
  id: string;
  audience: NotificationAudience;
  tenantId: string | null;
  targetUserId: string | null;
  type: string;
  severity: string;
  title: string;
  body: string | null;
  actionUrl: string | null;
  createdByUserId: string;
  recipientCount: number;
  bodyFormat: string | null;
  createdAt: string;
  updatedAt: string;
  revokedAt?: string | null;
  revokedByUserId?: string | null;
  tenantName?: string | null;
  targetUserName?: string | null;
  targetUserEmail?: string | null;
};

export type OperatorNotificationBroadcastListResponse = {
  items: OperatorNotificationBroadcastRecord[];
  total: number;
  page: number;
  pageSize: number;
};

export const operatorNotificationApi = {
  listBroadcasts: (params?: {
    audience?: NotificationAudience;
    page?: number;
    pageSize?: number;
  }) =>
    api.get<ApiResponse<OperatorNotificationBroadcastListResponse>>(
      '/operator/notifications/broadcasts',
      { params },
    ),

  getBroadcast: (id: string) =>
    api.get<ApiResponse<OperatorNotificationBroadcastRecord>>(
      `/operator/notifications/broadcasts/${id}`,
    ),

  broadcast: (data: OperatorNotificationBroadcastInput, idempotencyKey?: string) =>
    api.post<ApiResponse<OperatorNotificationBroadcastRecord>>(
      '/operator/notifications/broadcast',
      data,
      {
        headers: idempotencyKey ? { 'Idempotency-Key': idempotencyKey } : undefined,
      },
    ),

  revokeBroadcast: (id: string) =>
    api.post<ApiResponse<OperatorNotificationBroadcastRecord>>(
      `/operator/notifications/broadcasts/${id}/revoke`,
    ),

  deleteBroadcast: (id: string) =>
    api.delete<ApiResponse<{ id: string; deleted: boolean }>>(
      `/operator/notifications/broadcasts/${id}`,
    ),
};
